interface AppsRunningModalProps {
  apps: string[];
  onDismiss: () => void;
}

export const AppsRunningModal = ({ apps, onDismiss }: AppsRunningModalProps) => (
  <>
    <div className='absolute inset-0 z-40 rounded-[12px] bg-[#181818] opacity-[0.72]' />
    <div className='absolute inset-0 z-50 flex items-center justify-center p-4'>
      <div className='w-full rounded-[10px] border border-[#e4e4e4]/12 bg-[#181818] p-5'>
        <div className='flex w-full flex-col items-center gap-3'>
          <p className='m-0 text-center text-[20px] font-[590] leading-[26px] text-[#e4e4e4]/92'>
            These are still running
          </p>
          <p className='m-0 text-center text-[14px] font-normal leading-[20px] text-[#e4e4e4]/55'>
            They&apos;re fullscreen, so Host Mode would take this screen. Close them first, or cancel.
          </p>
          <div className='w-full max-h-[132px] overflow-y-auto rounded-[8px] border border-[#e4e4e4]/12 bg-[#e4e4e4]/[0.04]'>
            {apps.map((app) => (
              <div
                key={app}
                className='px-3 py-2 text-[13px] font-medium leading-[18px] text-[#e4e4e4]/80 border-b border-[#e4e4e4]/8 last:border-b-0'
              >
                {app}
              </div>
            ))}
          </div>
          <button
            type='button'
            onClick={onDismiss}
            className='w-full min-h-[44px] rounded-full border-none bg-[#FBBF24] px-4 py-3 text-[15px] font-semibold text-[#141414] cursor-pointer transition-transform hover:scale-[1.02] active:scale-[0.98]'
          >
            I&apos;ll close them
          </button>
          <button
            type='button'
            onClick={onDismiss}
            className='flex w-full items-center justify-center rounded-full border border-transparent bg-transparent px-1.5 py-0 text-[14px] font-medium leading-[20px] text-[#e4e4e4]/55 cursor-pointer transition-colors hover:text-[#e4e4e4]/80'
            style={{ height: 24 }}
          >
            Cancel Host Mode
          </button>
        </div>
      </div>
    </div>
  </>
);
